<template>
  <v-container class="text-start" :class="$vuetify.display.mobile ? 'pa-0' : ''">
    <v-row v-if="isValidteam">
      <v-col >
        <v-alert v-if="!isPreview" title="FIGYELEM! Mindig mentsd el a változtatásokat!" type="warning"></v-alert>
      </v-col>
    </v-row>
    <v-row v-if="!isValidteam">
      <v-col>
        <v-alert
          title="FIGYELEM! A csapat adatai nincsenek megfelelően kitöltve! Kérjük adja meg a csapattagok és a felkészítő tanár adatait!"
          type="warning"></v-alert>
      </v-col>
    </v-row>
  </v-container>
  <v-divider></v-divider>
  <v-row v-if="isValidteam" class="align-center">
    <v-col cols="12" class="text-h5">Válassz egy feladatot:</v-col>
    <v-col cols="12">
      <v-sheet class="mx-auto">
        <v-slide-group show-arrows>
          <v-slide-group-item v-for="(task, index) in tasks" :key="index" v-slot="{ isSelected, toggle }">
            <v-btn :color="isSelected ? 'rsz500' : (selectedTask === index ? 'rsz500' : '')" class="ma-2" rounded
              :v-model="selectedTask" @click="toggle(); selectedTask = index">
              {{ index + 1 }}. Feladat
            </v-btn>
          </v-slide-group-item>
        </v-slide-group>
      </v-sheet>
    </v-col>
  </v-row>
  <v-divider></v-divider>
  <form-component :taskData="baseForm" :results="results" @formModEvent="handleFormMod">
  </form-component>
  <v-row>
    <v-col cols="6">
      <v-btn v-if="selectedTask !== null" color="rsz500" class="w-100" size="x-large"
        @click="() => submitForm()">MENTÉS</v-btn>
    </v-col>
    <v-col cols="6">
      <v-btn v-if="selectedTask !== null" color="rsz500" class="w-100" size="x-large"
        @click="() => isDoneDialog = true">BEFEJEZÉS</v-btn>
    </v-col>
    </v-row>
  <save-dialog v-if="isSaveDialogVisible && selectedTask !== null" :showdialog="isSaveDialogVisible"
    @dialogChange="handleDialogChange" />

  <save-dialog :showdialog="isDoneDialog" text="Biztosan szereté véglegesíteni a kitöltését?" okay-text="Igen" :shouldNo="true" @dialogChange="handleDialogChange" />
</template>

<script>
import { defineComponent } from 'vue'
import FormComponent from './FormComponent.vue'
import SaveDialog from './SaveDialog.vue'
import { set, isEqual, cloneDeep } from 'lodash/fp'
import { getFormType, getTasks } from '../services/formTypeServices'
import { getForm, postForm, makeDone } from '../services/formServices'
import { checkTeam } from '../services/userServices'
import { getAdminFormType } from '../services/adminServices'

export default defineComponent({
  name: 'FormsComponent',
  components: {
    FormComponent,
    SaveDialog,
  },
  props: {
    isPreview: {
      default: false,
      type: Boolean,
    },
    isForm: {
      default: false,
      type: Boolean,
    }
  },
  data() {
    return {
      selectedTask: null,
      isValidteam: true,
      tasks: [],
      baseForm: [],
      results: [],
      exResults: null,
      isSaveDialogVisible: false,
      isDoneDialog: false,
    }
  },

  async created() {
    await this.checkValidTeam()
    // if(!this.isValidteam) return
    await this.getTasks()
  },
  watch: {
    async selectedTask(val, old) {
      if (isNaN(val)) return
      const form = await getForm(this.$route.params.competitionId, val)

      if (this.exResults) {
        if (!isEqual(this.exResults, this.results)) {
          await this.submitForm(old)
        }
      }

      this.results = set(this.results, val, form)
      delete this.results['object Object']
      this.exResults = cloneDeep(this.results)
      if (this.baseForm[val]) return
      const result = this.isPreview ? await getAdminFormType(this.$route.params.competitionId, val) : await getFormType(this.$route.params.competitionId, val)
      this.baseForm = set(this.baseForm, val, result)
      delete this.baseForm['object Object']
    }
  },

  methods: {
    async getTasks() {
      this.tasks = await getTasks(this.$route.params.competitionId)
    },
    async checkValidTeam() {
      this.isValidteam = this.isPreview || this.isForm ? true : await checkTeam(this.$route.params.competitionId)
    },
    handleFormMod(data) {
      data.forEach(e => {
        this.results[e.key] = e.value
      })
    },
    handleDialogChange(value) {
      this.isSaveDialogVisible = false;
      if (!this.isDoneDialog) {
        return
      }
      this.isDoneDialog = false

      if(value) {
        this.doneForm()
      }
    },
    async submitForm(old) {
      if(!this.isPreview){
        await postForm({
          form: this.results,
          competitionId: this.$route.params.competitionId,
          isDone: false,
          sectionNumber: old != undefined ? old : this.selectedTask,
        })
      }
      this.isSaveDialogVisible = true;
      setTimeout(() => {
        this.isSaveDialogVisible = false;
      }, 1500);
    },
    async doneForm() {

      if(!this.isPreview){
        await postForm({
          form: this.results,
          competitionId: this.$route.params.competitionId,
          isDone: false,
          sectionNumber: this.selectedTask,
        })
        await makeDone(
          this.$route.params.competitionId,
        )
        this.$router.push('/competitions')
      }    
      
      this.isDoneDialog = false;
    }
  }
})
</script>
